import i18n from '@/i18n'
// 2026-10-18：已知动态菜单标题使用展示词典，权限标识保持原值。
import {translateUi} from '@/i18n/display'
// 2026-09-17：兼容生产商等分店的历史菜单键，仅映射显示文案，不改权限键或路由。
const routeTitleAliases = new Map<string, string>([
  ['platforminfo', 'platform.platforminfo'],
  ['accounts', 'platform.accounts'],
  ['platform.myaccount', 'financial.myaccount'],
  ['financial.withdraw', 'financial.withdrawal']
])
// 2026-07-23 15:30：翻译键不存在时回退原始文案，避免界面和操作日志出现 msg.route.*。
export const generateTitle = (title: any, fallbackTitle?: any): string => {
  const originalTitle = title == null ? '' : String(title)
  const translationKey = 'msg.route.' + (routeTitleAliases.get(originalTitle) || originalTitle)
  const locale = i18n.global as unknown as {te: (key: string) => boolean; t: (key: string) => string}
  if (originalTitle && locale.te(translationKey)) return locale.t(translationKey)
  // 2026-09-17：动态菜单缺少词条时使用接口中的名称，避免向用户显示英文功能标识。
  const fallbackName = fallbackTitle == null ? '' : String(fallbackTitle)
  return translateUi(fallbackName.trim() ? fallbackName : originalTitle)
}
